import store from '@/store'

export default {
  getCurrency () {
    const currentRegion = store.getters['regions/currentRegion'] || {}
    return currentRegion.currency
  },
}
